<template>
  <div class="corrup-report">
    <nav-title title="请选择您想反馈的问题点" icon="*"></nav-title>
    <div class="question-type">
      <van-checkbox-group v-model="result" :disabled="flag">
        <div class="question-item">
          <van-checkbox
            name="功能异常功能故障或不可用"
            shape="square"
            checked-color="#36C490"
            >功能异常：功能故障或不可用</van-checkbox
          >
        </div>
        <div class="question-item">
          <van-checkbox
            name="产品建议用的不爽我有建议"
            shape="square"
            checked-color="#36C490"
            >产品建议：用的不爽，我有建议</van-checkbox
          >
        </div>
        <div class="question-item">
          <van-checkbox
            name="信息问题信息有误信息质疑等"
            shape="square"
            checked-color="#36C490"
            >信息问题：信息有误、信息质疑等</van-checkbox
          >
        </div>
        <div class="question-item">
          <van-checkbox name="其他问题" shape="square" checked-color="#36C490"
            >其他问题</van-checkbox
          >
        </div>
      </van-checkbox-group>
    </div>
    <nav-title title="请补充详细问题和意见" icon="*"></nav-title>

    <div class="message">
      <div v-if="flag" class="message-detail">{{ content }}</div>
      <van-field
        v-model="content"
        v-else
        rows="4"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入不少于10个字的描述"
        show-word-limit
      />
    </div>
    <nav-title
      title="请提供相关问题的截图或图片"
      v-if="!flag || (flag && fileList.length)"
    ></nav-title>
    <div class="uploader" v-if="!flag || (flag && fileList.length)">
      <van-uploader
        max-count="6"
        :after-read="afterRead"
        v-model="fileList"
        :deletable="!flag"
        :show-upload="!flag"
      >
        <!-- <van-button icon="photo" type="primary">上传文件</van-button> -->
        <div class="upload-btn">
          <img src="../../common/images/visa-change/upload.png" alt="" />
        </div>
      </van-uploader>
    </div>
    <div class="submit-btn">
      <van-button
        type="primary"
        block
        color="#36C490"
        loading-type="spinner"
        :loading="loading"
        @click="submit"
        v-if="!flag"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
import navTitle from '../recruitment-info/components/recruit-title';
import config from '@/config/index';
import {
  Button,
  Field,
  Uploader,
  Switch,
  Toast,
  Checkbox,
  CheckboxGroup
} from 'vant';
import axios from 'axios';
import OSS from 'ali-oss';
import { getUrlParams } from 'common/js/mUtils';

export default {
  components: {
    navTitle,
    [Button.name]: Button,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Switch.name]: Switch,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  data() {
    return {
      content: '',
      name: '',
      mobile: '',
      checked: false,
      fileList: [],
      ossConfig: {
        region: '',
        stsToken: '',
        accessKeyId: '',
        accessKeySecret: '',
        bucket: '',
        element: ''
      },
      body: {},
      flag: false,
      result: [],
      loading: false
    };
  },
  mounted() {
    // let url = config.baseURL;
    let url = 'https://api2.newhope.cn';
    axios.get(`${url}/auth/ossToken/stsToken`).then(res => {
      this.ossConfig.stsToken = res.body.SecurityToken;
      this.ossConfig.accessKeyId = res.body.AccessKeyId;
      this.ossConfig.accessKeySecret = res.body.AccessKeySecret;
      this.ossConfig.bucket = res.body.bucket;
      this.ossConfig.region = res.body.region.split('.')[0];
    });
  },

  methods: {
    handNotice() {
      this.$router.push({
        name: 'noticeReport'
      });
    },
    handswitch(ev) {},
    submit() {
      let url = [];
      let { fileList, name, mobile, content, result } = this;
      let { providerGuid } = getUrlParams();
      content = content.trim();

      if (result.length == 0) {
        Toast.fail('至少选择一条建议'); //duration
        return;
      }
      if (!content) {
        Toast.fail('请输入详细的问题和意见');
        return;
      }
      this.loading = true;
      fileList.map(item => url.push(item.url));
      let params = {
        items: result.join(','),
        content,
        type: '3',
        images: url.join(','),
        providerGuid
      };
      this.$api.complainSuggest(params).then(res => {
        if (res.code == '0000') {
          Toast.success('提交成功');
          this.loading = false;
          wx.miniProgram.switchTab({
            url: '/pages/complain-suggest/complain-suggest'
          });
        }
      });
    },
    ossUpload(file) {
      let that = this;
      return new Promise((resolve, reject) => {
        let client = new OSS(that.ossConfig);
        let bojName = 'dwwb/portal/project/' + new Date().getTime() + '/';
        async function putBlob() {
          try {
            let result = await client.put(bojName + file.name, file);
            resolve(result);
          } catch (e) {
            reject(e);
          }
        }
        putBlob();
      });
    },
    afterRead(files, detail) {
      let that = this;
      if (files.content) {
        files.status = 'uploading';
        files.message = '上传中...';
        this.ossUpload(files.file)
          .then(res => {
            if (res.url) {
              files.status = '';
              files.message = '';
              files.url = res.url;
              files.name = files.file.name;
              let arr = [];
              that.fileList.map(item => {
                let obj = {};
                obj.name = item.name;
                obj.url = item.url;
                arr.push(obj);
              });
              // eventBus.$emit('setValue', arr, that.data)
            } else {
              files.status = 'failed';
              files.message = '上传失败';
            }
            // that.$emit('validateField', '', that.data.uuid)
          })
          .catch(res => {
            files.status = 'failed';
            files.message = '上传失败';
          });
      }
    }
  },
  created() {
    let { info, id } = getUrlParams();
    if (info) {
      this.$api.corrupReportInfo({ id }).then(res => {
        let { code, body } = res;
        if (code == '0000' && body) {
          this.content = body.content;
          let images = (body.images && body.images.split(',')) || [];
          this.result = body.items.split(',');
          this.fileList = images.map(item => {
            return { url: item };
          });
        }
      });
      this.flag = true;
    } else {
      this.flag = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.corrup-report {
  background: #f5f5f5;
  height: 100%;
  padding-top: 20px;
  position: relative;
  .header {
    height: 88px;
    text-align: right;
    color: #36c490;
    font-size: 24px;
    line-height: 88px;
    padding-right: 34px;
  }
  .question-type {
    background: #fff;
    .question-item {
      height: 88px;
      border-bottom: 1px solid #efefef;
      line-height: 88px;
      padding-top: 28px;
      box-sizing: border-box;
      padding-left: 32px;
      color: #000;
      font-size: 28px;
    }
  }
  /deep/ .van-checkbox__label {
    color: #000;
    font-size: 28px;
  }
  .message {
    margin-bottom: 20px;
    .message-detail {
      padding: 20px 0px;
      padding-left: 32px;
      color: #9a9a9a;
      font-size: 28px;
      line-height: 1.5;
    }
  }
  .uploader {
    min-height: 244px;
    background: #fff;
    margin-bottom: 20px;
    /deep/.van-uploader__input-wrapper {
      padding: 24px 0px 20px 32px;
    }
    .upload-btn {
      min-width: 200px;
      min-height: 200px;
      img {
        width: 200px;
        height: 200px;
      }
    }
  }
  .van-cell:not(:last-child)::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0.32rem;
    border: none;
    transform: scaleY(0.5);
  }
  /deep/.van-uploader__preview-image {
    width: 200px !important;
    height: 200px !important;
    margin-top: 24px;
    margin-left: 32px;
  }
  .van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0.2rem 0.32rem;
    overflow: hidden;
    color: #323233;
    font-size: 0.28rem;
    line-height: 0.48rem;
    border-bottom: 1px solid #f5f5f5;
    background-color: #fff;
  }
  .submit-btn {
    margin: 0px 32px;
    margin-top: 88px;
    margin-bottom: 40px;
    // position: absolute;
    // bottom: 80px;
    // width: 686px;
    // left: 32px;
  }
  .report-type {
    padding-left: 32px;
    background: #f5f5f5;

    .title {
      color: #000;
      font-size: 32px;
      margin-bottom: 30px;
    }
    .item {
      margin-bottom: 35px;
      div {
        color: #999;
      }
      div:nth-child(1) {
        color: #000;
        font-size: 26px;
        margin-bottom: 20px;
      }
      div:not(:nth-child(1)) {
        line-height: 2;
      }
    }
  }
}
/deep/ .van-toast {
  width: auto !important;
}
</style>
